module.exports = __webpack_public_path__ + "static/media/hands.d80bdbc8.svg";